import { css } from '@emotion/css';

import {
  footerBarClassName,
  footerBarContainerClassName,
  footerBarWrapperClassName,
  footerColumnsDesktopContainerClassName,
  footerColumnsDesktopWrapperClassName,
  footerSocialClassName,
  footerSocialWrapperClassName,
} from '../../components/FooterV2/Footer.constants';
import { mobileMediaQuery, nonMobileMediaQuery, smallDesktopMediaQuery } from '../../constants';
import { m } from '../m';

const desktopEdgePadding = m('--spacing-xxxl');
const smallDesktopEdgePadding = m('--spacing-xl');

const footerBarsAfterCss = css`
  &::after {
    background-color: ${m('--footer-border-color')};
    content: '';
    height: 1px;
    position: absolute;
    top: 0;

    left: ${smallDesktopEdgePadding};
    width: calc(100% - calc(${smallDesktopEdgePadding} * 2));

    ${smallDesktopMediaQuery} {
      left: ${desktopEdgePadding};
      width: calc(100% - calc(${desktopEdgePadding} * 2));
    }

    ${mobileMediaQuery} {
      left: 0;
      width: 100%;
    }
  }
`;

export const snapFooterCss = css`
  .${footerSocialWrapperClassName} {
    border-top: none;
  }

  .${footerSocialClassName} {
    position: relative;
    ${footerBarsAfterCss}
  }

  /* FooterColumnDesktop container styles */
  .${footerColumnsDesktopContainerClassName} {
    position: relative;
    ${footerBarsAfterCss}
  }

  /* FooterColumnDesktop wrapper styles */
  .${footerColumnsDesktopWrapperClassName} {
    border-color: transparent;
  }

  .${footerBarWrapperClassName} {
    border: none;
    text-transform: uppercase;
  }

  .${footerBarClassName} {
    /* Unset max-width to allow for 1920 width footer bar content. We unset since the max width is set
  on the parent footerBarContainerCss */
    max-width: unset;

    /* Allow text to wrap on mobile to prevent screen overflow for locales with long names (e.g. German) */
    ${mobileMediaQuery} {
      & > ul > li > a {
        white-space: normal;
      }
    }

    ${nonMobileMediaQuery} {
      flex-wrap: wrap;
      gap: ${m('--spacing-l')};
      justify-content: start;
      padding-block: ${m('--spacing-m')};
      padding-inline: ${m('--spacing-xl')};

      /* Push the language selector to the right */
      & > div:last-child {
        margin-inline-start: auto;
      }

      /* Allow the groups of links to wrap to prevent screen overflow for locales with long names (e.g. German) */
      & > div > ul {
        flex-wrap: wrap;
      }
    }

    ${smallDesktopMediaQuery} {
      padding-inline: ${m('--spacing-xxxl')};
    }

    label {
      font-weight: ${m('--action-desktop-font-weight')};

      /** Hide "Language" label on mobile */
      ${mobileMediaQuery} {
        display: none;
      }
    }
  }

  .${footerBarContainerClassName} {
    position: relative;
    ${footerBarsAfterCss}
  }
`;
